import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Campus } from 'src/app/core/models/api/campus.model';
import { Subscriber } from 'src/app/core/models/api/subscriber.model';
import { CampusResourceService } from 'src/app/core/services/api/campus-resource.service';
import { SubscriberService } from 'src/app/core/services/api/subscriber.service';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

    @Input() campus: Campus;
    
    nameFormControl   = new FormControl('', [Validators.required]);
    mailFormControl   = new FormControl('', [Validators.required, Validators.email]);
    messageFormControl= new FormControl('', [Validators.required]);

    authorization: string;
    lopd         : string;
    lopdChecked  : boolean = false;
    
    constructor(
        private subscriberService: SubscriberService, 
        private modalService: ModalService, 
        private campusResourceService: CampusResourceService) { }

    ngOnInit() {

        this.getCampusResources();

    }

    getCampusResources() {

        this.authorization = this.campusResourceService.findResource(this.campus.resources, 'contact-authorization');
        this.lopd          = this.campusResourceService.findResource(this.campus.resources, 'contact-lopd');
        
    }

    sendContactForm() {

        var subscriber = new Subscriber();
            subscriber.campusId = this.campus.campusId;
            subscriber.name     = this.nameFormControl.value;
            subscriber.mail     = this.mailFormControl.value;
            subscriber.message  = this.messageFormControl.value;

        this.subscriberService.subscribeByContactForm(subscriber).subscribe(
            () => {     
                this.cleanContactForm();            
                this.modalService.showConfirmationModal(
                    "Su formulario se ha enviado correctamente.<br/>",
                    "¡Muchas gracias!"
                ); 
            }
        );

    }

    cleanContactForm() {

        this.nameFormControl.reset();
        this.mailFormControl.reset();
        this.messageFormControl.reset();
        this.lopdChecked = false;

    }

}
